import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import { LoginImg1, LoginImg2, LoginImg3, logo } from "../../imagepath";
import Swal from "sweetalert2";

const SelectRegister = () => {
  const params = new URLSearchParams(window.location.search);
  const reemCode = params.get("reemcode");

  var settings = {
    items: 2,
    margin: 25,
    dots: true,
    nav: true,
    navText: [
      '<i className="fas fa-arrow-left"></i>',
      '<i className="fas fa-arrow-right"></i>',
    ],

    loop: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 1,
      },
      1170: {
        items: 1,
      },
    },
  };
  const slides = [
    {
      image: LoginImg1,
      title: "Welcome to ",
      subtitle: " AngelWatchLMS Courses",
      content: `The AngelWatch National Certification Program is the first
      and only emergency training system of its kind—specifically designed to prepare teachers, school
      staff, and childcare providers to respond instantly and effectively in real-world crisis situations. Developed
      after 9/11 and previously used to protect U.S. government facilities around the world, this elite training is now
      available for civilian application for the very first time.
      <br /><strong>AngelWatch is:</strong><br />
      Partnered with the American Red Cross and the American Heart Association, and backed by the Department of Homeland Security — built in collaboration with the Department of Defense and the Department of Emergency Management.`
    },
    {
      image: LoginImg2,
      title: "Welcome to ",
      subtitle: " AngelWatchLMS Courses",
      content: `Legal Notice: All training content, techniques, software
      systems, and hardware demonstrated within the AngelWatch Certification Program are copyrighted, trademarked, and
      patented in the United States. This intellectual property is the exclusive legal property of AngelWatch and is
      protected by federal law. Unauthorized use, reproduction, adaptation, or the creation of derivative courses or
      materials based on this program is strictly prohibited and will result in legal action. Any individual or
      organization found attempting to mimic, copy, or alter any aspect of the AngelWatch training system will be held
      accountable to the fullest extent of the law. We maintain strict protection of this content to ensure that the
      quality, accuracy, and life-saving integrity of our training is never compromised or "dumbed down." This is
      critical to ensuring the safety of your staff, teachers, and the children in your care.`
    },
    {
      image: LoginImg3,
      title: "Welcome to ",
      subtitle: " AngelWatchLMS Courses",
      content: `It is fully online, available on-demand 24/7, and provides
      12 months of unlimited access for your entire staff—making it ideal for initial training, new hires, and
      recertification without disrupting your operations. Each center also receives a FREE Emergency Management Protocol
      Handbook, making you instantly compliant with state-mandated emergency planning—with no extra work. This
      course is so unique and valuable, it is copyrighted, trademarked, and patented in the United States. AngelWatch
      doesn't just teach policies. It trains instinct, builds confidence, and saves lives. Train now. Be ready. Stay
      alive. Due to the nature of this training and the sensitive security content involved, all AngelWatch
      Certification Program purchases are final. Because our course materials are designed to protect children, staff,
      and educational facilities—and include proprietary, copyrighted, and patented content—no refunds will be
      issued after enrollment. We appreciate your understanding and commitment to safety.`
    }
  ];
  return (
    <>
      <div className="main-wrapper log-wrap">
        <div className="row">
          {/* Login Banner */}

          <div className="col-md-6 login-bg">
            <div id="loginCarousel" className="carousel slide" data-bs-ride="carousel">
              <div className="carousel-inner">
                {slides.map((slide, index) => (
                  <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
                    <div className="welcome-login">
                      <div className="login-banner">
                        <img src={slide.image} className="d-block w-100" alt={`Slide ${index + 1}`} />
                      </div>
                      <div className="mentor-course text-center">
                        <h2 style={{ fontFamily: "Fredoka" }}>
                          {slide.title}
                        </h2>
                        <h1 style={{ fontFamily: "Fredoka", color: "white", fontWeight: "bold" }}>
                          {slide.subtitle}
                        </h1>
                        <p
                          style={{ fontFamily: "Poppins" }}
                          dangerouslySetInnerHTML={{ __html: slide.content }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#loginCarousel"
                data-bs-slide="prev"
              >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                {/* <span className="visually-hidden">Previous</span> */}
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#loginCarousel"
                data-bs-slide="next"
              >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          {/* /Login Banner */}
          <div className="col-md-6 login-wrap-bg">
            {/* Login */}
            <div className="login-wrapper">
              <div className="loginbox">
                <div className="img-logo">
                  <img src={logo} className="img-fluid" alt="Logo" />
                  <div className="back-home">
                    <Link to={process.env.REACT_APP_URL || "/"}>Back to Home</Link>
                  </div>
                </div>
                <h1>Sign up with</h1>
                <form>
                  <div className="d-grid">
                    <Link
                      className="btn  btn-start"
                      to={reemCode ? `/schoolregister/school?reemcode=${reemCode}` : `/schoolregister/school`}
                    >
                      School/Daycare
                    </Link>
                  </div>
                  <br />
                  <div className="d-grid">
                    <Link
                      className="btn  btn-start"
                      to={reemCode ? `/teacherregister/teacher?reemcode=${reemCode}` : `/teacherregister/teacher`}
                    >
                      School Teacher/Daycare worker
                    </Link>
                  </div>
                  <br />
                  <div className="d-grid">
                    <Link
                      className="btn  btn-start"
                      to="/individualteacherregister"
                    >
                      Individual Teacher
                    </Link>
                  </div>
                  {/* <div className="d-grid">
                    <Link
                      className="btn btn-primary btn-start"
                      to="/register/individual"
                    >
                      Individual Teacher
                    </Link>
                  </div> */}
                </form>
              </div>
            </div>
            {/* /Login */}
          </div>
        </div>
      </div>
    </>
  );
};

export default SelectRegister;
